import { popupConstants } from "../_constants";

export function popup(state = { fetchingDetail: false, detail: {} }, action) {
  switch (action.type) {
    case popupConstants.DETAIL_REQUEST:
      return {
        fetchingDetail: true
      };
    case popupConstants.DETAIL_SUCCESS:
      return {
        fetchingDetail: false,
        detail: action.detail
      };
    case popupConstants.DETAIL_FAILURE:
      return {
        error: action.error
      };
    case popupConstants.SAVE_CLOSE_REQUEST:
      return {
        fetchingDetail: true
      };
    case popupConstants.SAVE_CLOSE_SUCCESS:
      return {
        fetchingDetail: false,
        detail: action.detail
      };
    case popupConstants.SAVE_CLOSE_FAILURE:
      return {
        error: action.error
      };
    default:
      return state;
  }
}
